var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"svg-box"},[_c('svg',{attrs:{"width":"100%","height":"100%","version":"1.1"}},_vm._l((_vm.points),function(item,index){return _c('polygon',{staticStyle:{"fill":"rgba(0,0,255,0.1)","stroke":"#000000","stroke-width":"1"},attrs:{"points":item.ps}})}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }